import React from 'react';

import { Breadcrumb } from '../../components/Breadcrumb';
import { DashboardCard } from '../../components/DashboardCard';
import { IconButton } from '../../components/IconButton';

// Icon placeholders (reuse existing public assets)
const iconPulse = '/figma_asset/Trello.svg';
const iconPsg = '/figma_asset/Disc.svg';
const iconCpap = '/figma_asset/Cpu.svg';

const ManageMachinePage: React.FC = () => {
  return (
    <div className="flex flex-col w-full gap-[40px]">
      <Breadcrumb
        items={[{ label: 'ホーム', href: '/dashboard' }, { label: '企業リスト' }]}
        separator="＜"
        showLeadingSeparator
      />
      <div className="flex items-center justify-between w-full">
        <h1 className="text-[28px] font-medium text-black leading-none">機器在庫管理</h1>
        <IconButton
          label="新規登録"
          iconSrc="/figma_asset/Plus square.svg"
          iconAlt="新規登録"
          iconPosition="left"
          variant="primary"
        />
      </div>
      <div className="flex gap-[30px] w-full">
        <DashboardCard title="パルス" subtitle="予約・進捗管理" icon={iconPulse} variant="normal" />
        <DashboardCard
          title="PSG"
          subtitle="企業一覧・登録／解除"
          icon={iconPsg}
          variant="strong"
        />
        <DashboardCard
          title="CPAP"
          subtitle="企業一覧・登録／解除"
          icon={iconCpap}
          variant="normal"
        />
      </div>
    </div>
  );
};

export default ManageMachinePage;
